/* Fixed version of main.js with custom-select error handling */

jQuery(function($) {
    // Select2 initialization
    $('.theme-vitalshop:not(.wp-admin) select:not(.top-bar select, .topic-filters select, .acf-field select, .ignore-select2, #billing_country, #shipping_country)').select2({
        minimumResultsForSearch: -1
    });

    $('#billing_country, #shipping_country').select2({});

    // International phone input setup
    if ($('#shipping_phone') && $('#shipping_phone').length) {
        window.intlTelInput(document.querySelector('#shipping_phone'), {
            initialCountry: "auto",
            nationalMode: false,
            autoPlaceholder: "aggressive",
            autoHideDialCode: true,
            formatOnDisplay: true,
            customPlaceholder: function(placeholder, countryData) {
                return "e.g. " + placeholder;
            },
            geoIpLookup: function(success, failure) {
                $.get("https://ipinfo.io", function() {}, "jsonp").always(function(resp) {
                    var countryCode = (resp && resp.country) ? resp.country : "us";
                    success(countryCode);
                });
            }
        });
    }

    if ($('#billing_phone') && $('#billing_phone').length) {
        window.intlTelInput(document.querySelector('#billing_phone'), {
            initialCountry: "auto",
            nationalMode: false,
            autoPlaceholder: "aggressive",
            autoHideDialCode: true,
            formatOnDisplay: true,
            customPlaceholder: function(placeholder, countryData) {
                return "e.g. " + placeholder;
            },
            geoIpLookup: function(success, failure) {
                $.get("https://ipinfo.io", function() {}, "jsonp").always(function(resp) {
                    var countryCode = (resp && resp.country) ? resp.country : "us";
                    success(countryCode);
                });
            }
        });
    }

    // WooCommerce variation handling
    $(document).on('woocommerce_variation_select_change', function(e) {
        $('form.cart select, .woocommerce-ordering select, #product-order-select').select2('destroy').select2({
            minimumResultsForSearch: -1
        });
    });

    $(document).on('woocommerce_variation_has_changed', function(e) {
        $('form.cart select, .woocommerce-ordering select, #product-order-select').select2('destroy').select2({
            minimumResultsForSearch: -1
        });
    });

    // Mobile navigation
    $(document).on('click', '.mobile-nav-icon, .close-mobile-nav', function() {
        $('body').toggleClass('mobile-menu-open');
    });

    $(document).on('click', '#mobile-navigation .menu-item-has-children > a', function(e) {
        e.preventDefault();
        if ($(this).closest('.menu-item-has-children').hasClass('active')) {
            $(this).closest('.menu-item-has-children').removeClass('active');
        } else {
            $('#mobile-navigation .menu-item-has-children').removeClass('active');
            $(this).closest('.menu-item-has-children').addClass('active');
        }
    });

    // Desktop navigation
    $(document).on('click', '.desktop-navigation .menu-item-has-children', function(e) {
        e.preventDefault();
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $('.mega-menus-container .mega-menu').removeClass('active');
        } else {
            $('.mega-menus-container .mega-menu').removeClass('active');
            $('.desktop-navigation .menu-item-has-children').removeClass('active');
            $('#' + $(this).attr('id').replace('menu-item-', 'mega-menu-')).addClass('active');
            $(this).addClass('active');
        }
    });

    // Close mega menu when clicking outside
    $(document).click(function(e) {
        var $target = $(e.target);
        if (!$target.closest('.mega-menu.active .mega-menu-content').length && 
            $('.mega-menu.active').length && 
            !$target.closest('.desktop-navigation .menu-item-has-children').length) {
            $('.mega-menus-container .mega-menu.active').removeClass('active');
            $('.desktop-navigation .menu-item-has-children').removeClass('active');
        }
    });

    // Mobile menu fader
    $('#masthead .fader').click(function() {
        $('body').removeClass('mobile-menu-open');
    });

    // Accordion functionality
    $(document).on('click', '.accordion .accordion-item .accordion-item-heading, .accordion .accordion-close', function(e) {
        e.preventDefault();
        if ($(this).closest('.accordion').attr('keep-others') == 1) {
            $(this).closest('.accordion-item').toggleClass('expanded');
        } else {
            if ($(this).closest('.accordion-item').hasClass('expanded')) {
                $(this).closest('.accordion-item').removeClass('expanded');
            } else {
                $(this).closest('.accordion').find('.accordion-item').removeClass('expanded');
                $(this).closest('.accordion-item').addClass('expanded');
            }
        }
    });

    // WooCommerce tabs
    $(document).on('click', '.woocommerce-tabs .tabs.wc-tabs li', function(e) {
        var tabId = $(this).attr('aria-controls');
        $('.woocommerce-tabs .tabcordion-title').each(function() {
            if ($(this).attr('aria-controls') === tabId) {
                $(this).addClass('active');
            } else {
                $(this).removeClass('active');
            }
        });
    });

    $(document).on('click', '.woocommerce-tabs .tabcordion-title', function(e) {
        e.preventDefault();
        e.stopPropagation();
        $('.woocommerce-tabs .tabcordion-title').removeClass('active');
        $(this).addClass('active');
        var tabId = $(this).attr('aria-controls');
        $('.wc-tabs li').each(function() {
            if ($(this).attr('aria-controls') === tabId) {
                $(this).addClass('active');
            } else {
                $(this).removeClass('active');
            }
        });
        $('.woocommerce-Tabs-panel').css('display', 'none');
        $('#' + tabId).css('display', 'block');
    });

    // Smooth scroll for anchor links
    $(document).on('click', 'a[href*=\\#]:not([href=\\#]):not(.wc-tabs a):not(.woocommerce-tabs a)', function(e) {
        var target = $(this).prop('hash');
        if ($(target).length) {
            e.preventDefault();
            $('body').removeClass('mobile-menu-open');
            $('html, body').animate({
                scrollTop: $($(target)).offset().top - $('#masthead').outerHeight() - 40
            }, 500, 'linear');
        }
    });

    // Scroll detection
    $(window).scroll(function() {
        if ($(window).scrollTop() >= 500) {
            $('body').addClass('scrolled-down');
        } else {
            $('body').removeClass('scrolled-down');
        }
    });

    // Scroll to top
    $('#scroll-to-top').click(function() {
        $('html, body').animate({scrollTop: 0}, 'slow');
        return false;
    });

    $('.to-top-link').click(function(e) {
        e.preventDefault();
        $('html, body').animate({scrollTop: 0}, 'slow');
        return false;
    });

    // Wishlist checkboxes
    $(document).ready(function() {
        $('.tinvwl-table-manage-list input[type="checkbox"]').wrap('<label></label>').after('<span></span>');
    });

    // Viewport height fix for mobile
    $(window).load(function() {
        var vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', vh + 'px');
    });

    $(window).resize(function() {
        var vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', vh + 'px');
    });
});

// Fixed Custom Select functionality
(function() {
    'use strict';
    
    var x, i, j, selElmnt, a, b, c;
    
    /* Look for any elements with the class "custom-select": */
    x = document.getElementsByClassName('custom-select');
    
    for (i = 0; i < x.length; i++) {
        selElmnt = x[i].getElementsByTagName('select')[0];
        
        // Skip if no select element found or no options
        if (!selElmnt || !selElmnt.options || selElmnt.options.length === 0) {
            continue;
        }
        
        /* For each element, create a new DIV that will act as the selected item: */
        a = document.createElement('DIV');
        a.setAttribute('class', 'select-selected');
        a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
        x[i].appendChild(a);
        
        /* For each element, create a new DIV that will contain the option list: */
        b = document.createElement('DIV');
        b.setAttribute('class', 'select-items select-hide');
        
        for (j = 1; j < selElmnt.length; j++) {
            /* For each option in the original select element,
            create a new DIV that will act as an option item: */
            c = document.createElement('DIV');
            c.innerHTML = selElmnt.options[j].innerHTML;
            c.addEventListener('click', function(e) {
                /* When an item is clicked, update the original select box,
                and the selected item: */
                var y, i, k, s, h;
                s = this.parentNode.parentNode.getElementsByTagName('select')[0];
                h = this.parentNode.previousSibling;
                
                if (!s || !s.options) {
                    return;
                }
                
                for (i = 0; i < s.length; i++) {
                    if (s.options[i].innerHTML == this.innerHTML) {
                        s.selectedIndex = i;
                        h.innerHTML = this.innerHTML;
                        y = this.parentNode.getElementsByClassName('same-as-selected');
                        for (k = 0; k < y.length; k++) {
                            y[k].removeAttribute('class');
                        }
                        this.setAttribute('class', 'same-as-selected');
                        break;
                    }
                }
                h.click();
                s.dispatchEvent(new Event('change'));
            });
            b.appendChild(c);
        }
        x[i].appendChild(b);
        
        a.addEventListener('click', function(e) {
            /* When the select box is clicked, close any other select boxes,
            and open/close the current select box: */
            e.stopPropagation();
            closeAllSelect(this);
            this.nextSibling.classList.toggle('select-hide');
            this.classList.toggle('select-arrow-active');
        });
    }

    function closeAllSelect(elmnt) {
        /* A function that will close all select boxes in the document,
        except the current select box: */
        var x, y, i, arrNo = [];
        x = document.getElementsByClassName('select-items');
        y = document.getElementsByClassName('select-selected');
        
        for (i = 0; i < y.length; i++) {
            if (elmnt == y[i]) {
                arrNo.push(i);
            } else {
                y[i].classList.remove('select-arrow-active');
            }
        }
        
        for (i = 0; i < x.length; i++) {
            if (arrNo.indexOf(i)) {
                x[i].classList.add('select-hide');
            }
        }
    }

    /* If the user clicks anywhere outside the select box,
    then close all select boxes: */
    document.addEventListener('click', closeAllSelect);
    
})();
